import { Component } from "../../../../commons/types/component";
import cn from "../../libs/class-name";

const Hr = ({ classNames = [] }: Component) => <hr className={cn("Hr", [], classNames)} />;

export default Hr;
